module.exports = __webpack_public_path__ + "static/media/plus_icon.0ab97b61.svg";